<template>
    <div class="frame-content">
        <div class="frame-content-wrap">
            <div class="datatable-wrap">
                <div class="topbar">
                    <div class="inline">
                        <el-button type="primary" size="small" @click="handleAdd">新增</el-button>
                    </div>
                    <div class="inline ml-8">
                        <el-button type="danger" size="small" @click="handleDeleteAll">删除</el-button>
                    </div>
                </div>
                <div class="datatable">
                    <el-table
                        ref="currentTable"
                        :data="tableData"
                        v-loading="tableLoading"
                        element-loading-background="rgba(255, 255, 255, 0.3)"
                        border
                        style="width: 100%">
                        <el-table-column
                            type="selection"
                            width="55"
                            align="center">
                        </el-table-column>
                        <el-table-column
                            label="序号"
                            align="center"
                            width="80">
                            <template slot-scope="scope">
                                <span>{{ (curPageNum - 1) * pageSize + scope.$index + 1}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="工种名称"
                            min-width="200">
                            <template slot-scope="scope">
                                <template v-if="!tableStateData[scope.row.id].edit">{{ scope.row.name }}</template>
                                <el-input v-else v-model="tableStateData[scope.row.id].name" size="mini"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="status"
                            label="状态（禁用/启用）"
                            align="center"
                            width="160">
                            <template slot-scope="scope">
                                <el-switch
                                    v-model="scope.row.status"
                                    :active-color="scope.row.type === 1 ? '#999' : '#13ce66'"
                                    inactive-color="#ff4949"
                                    :disabled="scope.row.type === 1"
                                    @change="handleStatusChange($event, scope.row)">
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="action"
                            label="操作"
                            align="center"
                            width="220">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="!tableStateData[scope.row.id].edit"
                                    size="mini"
                                    type="primary"
                                    @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                                <el-button
                                    v-if="tableStateData[scope.row.id].edit"
                                    size="mini"
                                    type="primary"
                                    @click="handleSave(scope.$index, scope.row)">保存</el-button>
                                <el-button
                                    v-if="tableStateData[scope.row.id].edit"
                                    size="mini"
                                    type="primary"
                                    @click="handleCancel(scope.$index, scope.row)">取消</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @curRule-change="handleCurRuleChange"
                        :background="true"
                        :curRule-page="pageNum"
                        :page-sizes="[50, 100, 200, 300, 400, 500]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalNum">
                    </el-pagination>
                </div>
            </div>

            <el-dialog
                title="新增工种"
                v-if="addDialog.create"
                :visible.sync="addDialog.visible"
                :close-on-click-modal="false"
                @closed="handleAddClosed"
                class="custom-dialog mini-dialog"><!-- big-dialog small-dialog mini-dialog  -->
                <WorkTypeAdd @done="handleAddDone"></WorkTypeAdd>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import common from '@/utils/common'
import http from '@/utils/http'
import WorkTypeAdd from './WorkTypeAdd'

export default {
    name: 'WorkType',
    components: {
        WorkTypeAdd,
    },
    data() {
        return {
            filters: {
            },

            tableData: [],
            tableStateData: {},

            totalNum: 0,
            pageNum: 1,
            pageSize: 50,

            curPageNum: 1,

            tableLoading: false,

            detailDialog: {
                create: false,
                visible: false,
                params: {},
            },

            addDialog: {
                create: false,
                visible: false,
            },

            editDialog: {
                create: false,
                visible: false,
                params: {},
            },
        };
    },
    created () {
        this.loadTable();
    },
    methods: {
        ...common,
        // 加载表格数据
        loadTable() {
            let params = {...this.filters};

            params.pageNum = this.pageNum;
            params.pageSize = this.pageSize;

            this.tableLoading = true;
            http.get('v1/workType/page', {
                params: params
            }).then(req => {
                this.tableLoading = false;
                if (req.data.code == http.SUCCESS) {
                    this.tableData = req.data.data.records;

                    this.tableData.forEach(item => {
                        item.status = item.status == 1;
                    });

                    this.tableStateData = {};
                    this.tableData.forEach(row => {
                        this.tableStateData[row.id] = {
                            name: row.name,
                            edit: false,
                        };
                    });

                    this.totalNum = req.data.data.total;
                    this.curPageNum = this.pageNum;
                } else {
                    this.showError(req.data.msg);
                }
            }).catch(err => {
                this.tableLoading = false;
                this.httpCatch(err);
            });
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.loadTable();
        },
        handleCurRuleChange(pageNum) {
            this.pageNum = pageNum;
            this.loadTable();
        },

        // 添加弹窗口
        handleAdd() {
            this.addDialog = { create: true, visible: false };
            this.$nextTick(() => {
                this.addDialog = { create: true, visible: true };
            });
        },
        handleAddDone() {
            this.addDialog = { visible: false };
            this.loadTable();
        },
        handleAddClosed() {
            this.addDialog = { create: false, visible: false };
        },

        // 编辑
        handleEdit(index, row) {
            let item = { ...this.tableStateData[row.id], edit: true };
            this.tableStateData[row.id] = item;
            this.tableStateData = { ...this.tableStateData };
        },
        handleSave(index, row) {
            let { name } = this.tableStateData[row.id];
            http.post('v1/workType/edit', { id: row.id, name: name }).then(req => {
                if (req.data.code == http.SUCCESS) {
                    this.loadTable();
                    this.showSuccess('保存成功！');
                } else {
                    this.showError(req.data.msg);
                }
            }).catch(err => {
                this.tableLoading = false;
                this.httpCatch(err);
            });
        },
        handleCancel(index, row) {
            let item = { ...row, edit: false };
            this.tableStateData[row.id] = item;
            this.tableStateData = { ...this.tableStateData };
        },

        handleStatusChange(value, row) {
            let status = 0;
            if (value) {
                status = 1;
            }
            let text = status == 1 ? '启用' : '禁用';

            http.post('v1/workType/status', { id: row.id, status: status }).then(req => {
                if (req.data.code == http.SUCCESS) {
                    this.loadTable();
                    this.showSuccess(text + '成功！');
                } else {
                    this.showError(req.data.msg);
                }
            }).catch(err => {
                this.tableLoading = false;
                this.httpCatch(err);
            });
        },

        handleDeleteAll() {
            if (this.$refs.currentTable.selection.length == 0) {
                this.showError('请选择要删除的工种！');
            } else {
                this.confirm('确认删除所选工种？', function () {
                    let idarr = [];
                    for (let i = 0; i < this.$refs.currentTable.selection.length; i++) {
                        idarr.push(this.$refs.currentTable.selection[i].id);
                    }
                    http.post('v1/workType/delete', { ids: idarr }).then(req => {
                        if (this.httpThen(req)) {
                            return;
                        }
                        if (req.data.code == http.SUCCESS) {
                            this.loadTable();
                            this.showSuccess('删除成功！');
                        } else {
                            this.showError(req.data.msg);
                        }
                    });
                });
            }
        },
    }
}
</script>

<style scoped>
</style>
